export const gsq = {
  name: 'gsq',
  mounted: (el, binding) => {
    const analyticsData = binding.value;
    el.addEventListener('click', () => {
      window._gsq.push(analyticsData);
    });
  },
};
